<template>
  <div class="exam">
    <div class="nuv">
      <span>学员明细情况&nbsp;&gt;</span>
      <span>{{ groupName }}</span>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="总学习学员名单" name="first">
        <label>淘金客：</label>
        <tjkautocomplete @callBack="updateTjkId"></tjkautocomplete>
        <label>基础培训老师：</label>
        <el-select v-model="teacherId" clearable placeholder="请选择">
          <el-option v-for="(ll, key) in teacherList" :key="ll.roleId" :label="ll.tjkName" :value="ll.roleId"></el-option>
        </el-select>
        <label>所属群：</label>
        <el-input v-model="queryGroupId" placeholder="请输入群ID" style="width: 150px;"></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="getList(1)">查询</el-button>
        <el-table :data="totalList" border style="width: 100%;margin-top: 20px;">
          <el-table-column prop="tjkName" label="姓名" width="180" align="center"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号" align="center"></el-table-column>
          <el-table-column prop="groupName" label="所属群" align="center"></el-table-column>
          <el-table-column prop="teacherName" label="培训老师" align="center"></el-table-column>
          <el-table-column label="学习进度" align="center">
            <template slot-scope="scope">{{scope.row.progress}}%</template>
          </el-table-column>
          <el-table-column prop="lastStudyTime" label="最近学习时间" align="center"></el-table-column>
          <el-table-column prop="loseState" label="学员状态" align="center"></el-table-column>
        </el-table>
        <pagination :pages="pages" :pageNum="pageNum" @getData="getList"></pagination>
      </el-tab-pane>
      <el-tab-pane v-for="(item, index) in tabList" :key="item.courseId" :label="item.courseName" :name="getString(item.courseId)">
        <label>淘金客：</label>
        <tjkautocomplete @callBack="updateTjkId"></tjkautocomplete>
        <el-button type="danger" style="margin-left: 10px;" @click="getLinkageList(1)">查询</el-button>
        <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
        <template v-else>
          <p class="tj-shift-notice" v-if="!linkageList.length" style="padding-top: 45px;">暂无记录！</p>
          <template v-else>
            <el-table ref="multipleTable" border :data="linkageList" tooltip-effect="dark" style="width: 100%;margin-top: 20px;" @selection-change="handleSelectionChange">
              <el-table-column type="selection" align="center"></el-table-column>
              <el-table-column prop="realName" label="姓名" align="center"></el-table-column>
              <el-table-column prop="tjkNumber" label="淘金号" align="center"></el-table-column>
              <el-table-column label="学习进度" align="center">
                <template slot-scope="scope">{{scope.row.progress}}%</template>
              </el-table-column>
              <el-table-column prop="lastStudyTime" label="最近学习时间" align="center"></el-table-column>
              <el-table-column prop="isPassed" label="操作" align="center">
                <template slot-scope="scope">
                  <template v-if="scope.row.isPassed == 'No'">
                    <el-button type="text" @click="passSingle(scope.row.evaluationId)">通过</el-button>
                  </template>
                  <template v-else-if="scope.row.isPassed == 'Yes'">已通过</template>
                  <template v-else></template>
                </template>
              </el-table-column>
            </el-table>
            <div class="tj-margin-top-xl">
              <el-button type="primary" @click="passEvaluations">学员通过课程</el-button>
            </div>
            <pagination :pages="pages" :pageNum="pageNum" @getData="getLinkageList"></pagination>
          </template>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'pageNum': 1,
      'pageSize': 10,
      'pages': 1,
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.name,
      'activeName': 'first', //当前tab
      'tjkId': '', //搜索的淘金客id
      'queryGroupId': '', //所属群id
      'teacherId': '', //培训老师id
      'multipleSelection': [],
      'badgeName': '', //联动课程通过后获得徽章名称
      'totalList': [], //总学习学员名单列表
      'tabList': [], //联动课程tab查询
      'courseId': '', //当前联动课程id
      'linkageList': [], //联动课程列表
      'teacherList': [] //基础培训老师列表
    }
  },
  watch: {
    courseId: function() {
      for(var i=0;i<this.tabList.length;i++) {
        if(this.courseId == this.tabList[i].courseId) {
          this.badgeName = this.tabList[i].badgeName
        }
      }
    }
  },
  mounted: function() {
    this.getLinkageTab()
    this.getTeacherList()
    this.getList(1)
  },
  methods: {
    //查询培训老师列表
    getTeacherList() {
      this.$http.post(API_ROOT.teamTalk + '/basic/teacher/query').then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.teacherList = result.data
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //tab切换
    handleClick(tab) {
      if(tab.name == 'first') {
        this.getList(1)
      }else {
        this.courseId = tab.name
        this.getLinkageList(1)
      }
    },
    //总学习学员名单查询
    getList(num) {
      var data = {
        'groupId': this.groupId,
        'tjkId': this.tjkId,
        'queryGroupId': this.queryGroupId,
        'teacherId': this.teacherId,
        'pageNum': num,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.college + '/majors/queryTjkList', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.pageNum = result.data.pageNum
          this.pages = result.data.pages
          this.totalList = result.data.list
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //查询联动课程tab
    getLinkageTab() {
      var data = {
        'groupId': this.groupId
      }
      this.$http.post(API_ROOT.college + '/majors/queryLinkage', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.tabList = result.data
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //查询联动课程列表
    getLinkageList(num) {
      var data = {
        'courseId': this.courseId,
        'tjkId': this.tjkId,
        'pageNum': num,
        'pageSize': this.pageSize
      }
      this.$http.post(API_ROOT.college + '/courseExamine/queryByCourseId', data).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.pageNum = result.data.pageNum
          this.pages = result.data.pages
          this.linkageList = result.data.list
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //学员通过课程-单个操作
    passSingle(evaluationId) {
      var evaluationIds = []
      evaluationIds.push(evaluationId)
      var data = {
        'courseId': this.courseId,
        'evaluationIds': evaluationIds
      }
      this.passFunction(data)
    },
    //学员通过课程
    passEvaluations() {
      var ids = []
      this.multipleSelection.map((item)=> {
        ids.push(item.evaluationId)
      })
      if(ids.length == 0) {
        this.$alert('请先选择淘金客')
        return false
      }
      var data = {
        'courseId': this.courseId,
        'evaluationIds': ids
      }
      this.passFunction(data)
    },
    //通过操作-功能方法
    passFunction(data) {
      var self = this
      this.$confirm('标记学员通过课程将颁发"'+ this.badgeName + '徽章"给客服，确认名单无误？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.$http.post(API_ROOT.college + '/courseExamine/passEvaluations', data).then(response => {
          var result = response.data
          if(result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            })
            self.getLinkageList(this.pageNum)
          }else {
            self.$alert(result.msg)
          }
        }, response => {
          self.$alert('网络繁忙，请稍后重试！')
        })
      }).catch(() => {
                 
      })
    },
    //number转换为string
    getString(name) {
      return JSON.stringify(name)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //淘金客自动搜索
    updateTjkId(val) {
      this.tjkId = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/college/linkage.vue